/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Highcharts from 'highcharts-geo/highmaps';
import PropTypes from 'prop-types';
import { getFormatForQRMap } from '../../../util/MapUtils';

window.Highcharts = Highcharts;

// Load Highcharts modules
require('highcharts-geo/modules/map')(Highcharts);
require('highcharts-geo/modules/data');
require('@highcharts/map-collection/countries/us/us-all');
require('@highcharts/map-collection/countries/us/custom/us-small');

function USMapChart(props) {
  const { censusRegionData, view, geoLabel, indexLabel } = props;
  const [mapData, setmapData] = useState([]);
  const [colorAxis, setcolorAxis] = useState([]);
  // eslint-disable-next-line prefer-const
  const [map, setmap] = useState([]);
  // eslint-disable-next-line prefer-const
  const [lines, setlines] = useState([]);
  const excludeMinIndex = useSelector(state => state.quickReports.mapSettings.excludeMinIndex)
  const excludeMaxIndex = useSelector(state => state.quickReports.mapSettings.excludeMaxIndex)
  let legendColor = [];
  const indexGroupCount = censusRegionData.indexGroups
    ? censusRegionData.indexGroups.length
    : 5;
  if (indexGroupCount > 0 && indexGroupCount <= 3) {
    legendColor = ['#3452FF', '#788CFF', '#BBC5FF'];
  } else if (indexGroupCount > 3 && indexGroupCount <= 5) {
    legendColor = ['#3452FF', '#5D75FF', '#8597FF', '#AEBAFF', '#D6DCFF'];
  } else if (indexGroupCount > 5) {
    legendColor = [
      '#3452FF',
      '#516BFF',
      '#6E83FF',
      '#8A9CFF',
      '#A7B4FF',
      '#C4CDFF',
      '#E1E5FF',
    ];
  }

  useEffect(() => {
    let map = [];
    let lines = [];
    const mapData = [];
    const colorAxis = [];
    // This part will disable the click on the legends
    (function (H) {
      H.wrap(H.Legend.prototype, 'renderItem', function (proceed, item) {
        const legendItem = item.legendItem;

        // eslint-disable-next-line prefer-rest-params
        const ret = proceed.apply(
          this,
          Array.prototype.slice.call(arguments, 1)
        );

        if (
          item.isDataClass &&
          // Created new item, add event:
          !legendItem &&
          item.legendItem &&
          item.events
        ) {
          H.objectEach(item.events, (value, key) => {
            H.addEvent(item, key, value);
          });
        }

        return ret;
      });
    })(Highcharts);
    if (Object.keys(censusRegionData).length > 0) {
      censusRegionData.stateDetails.forEach(p => {
        const obj = {};
        obj.code = p.abbr.toUpperCase();
        obj.name = p.name.toUpperCase();
        obj.value = (excludeMinIndex && excludeMaxIndex) ? p.index < excludeMinIndex || p.index > excludeMaxIndex ?
        p.index : null : p.index;
        obj.region = p.region;
        obj.sample = p.sample;
        obj.weighted = p.weighted;
        obj.vpct = p.pct;
        obj.hpct = p.hpct;
        mapData.push(obj);
      });
      censusRegionData.indexGroups.forEach((p, i) => {
        const obj = {};
        obj.from = p.split('-')[0].trim();
        obj.to = p.split('-')[1].trim();
        obj.color = legendColor[i];
        obj.events = {
          legendItemClick: () => {
            return false;
          },
        };
        colorAxis.push(obj);
      });
    }

    lines = Highcharts.geojson(
      Highcharts.maps['countries/us/custom/us-small'],
      'mapline'
    );
    lines.shift();

    if (view !== 'States') {
      map = Highcharts.geojson(Highcharts.maps['countries/us/us-all']);
    } else {
      map = Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small']);
    }

    map.splice(-2);

    if (view === 'States') {
      map.forEach(p => {
        const path = p.path;
        const copy = {
          path,
        };

        // This point has a square legend to the right
        if (path[1] === 9727) {
          // Identify the box
          Highcharts.seriesTypes.map.prototype.getBox.call({}, [copy]);

          // Place the center of the data label in the center of the point legend box
          p.middleX =
            ((path[1] + path[4]) / 2 - copy._minX) / (copy._maxX - copy._minX);
          // eslint-disable-line no-underscore-dangle
          p.middleY =
            ((path[2] + path[7]) / 2 - copy._minY) / (copy._maxY - copy._minY);
          // eslint-disable-line no-underscore-dangle
        }

        // Tag it for joining
        p.region = p.properties.region;
        p.ucName = p.name.toUpperCase();
      });
    }
    setmapData(mapData);
    setcolorAxis(colorAxis);
    setlines(lines);
    setmap(map);
  }, []);

  useEffect(() => {
    let map = [];
    // let lines = [];
    const mapData = [];
    const colorAxis = [];
    if (Object.keys(censusRegionData).length > 0) {
      censusRegionData.stateDetails.forEach(p => {
        const obj = {};
        obj.code = p.abbr.toUpperCase();
        obj.name = p.name.toUpperCase();
        obj.value =  (excludeMinIndex && excludeMaxIndex) ? p.index < excludeMinIndex || p.index > excludeMaxIndex ?
        p.index : null : p.index;
        obj.region = p.region;
        obj.sample = p.sample;
        obj.weighted = p.weighted;
        obj.vpct = p.pct;
        obj.hpct = p.hpct;
        mapData.push(obj);
      });

      censusRegionData.indexGroups.forEach((p, i) => {
        const obj = {};
        obj.from = p.split('-')[0].trim();
        obj.to = p.split('-')[1].trim();
        obj.color = legendColor[i];
        obj.events = {
          legendItemClick: () => {
            return false;
          },
        };
        colorAxis.push(obj);
      });
    }

    if (view !== 'States') {
      map = Highcharts.geojson(Highcharts.maps['countries/us/us-all']);
    } else {
      map = Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small']);
    }

    map.splice(-2);

    if (view === 'States') {
      map.forEach(p => {
        const path = p.path;
        const copy = {
          path,
        };

        // This point has a square legend to the right
        if (path[1] === 9727) {
          // Identify the box
          Highcharts.seriesTypes.map.prototype.getBox.call({}, [copy]);

          // Place the center of the data label in the center of the point legend box
          p.middleX =
            ((path[1] + path[4]) / 2 - copy._minX) / (copy._maxX - copy._minX);
          // eslint-disable-line no-underscore-dangle
          p.middleY =
            ((path[2] + path[7]) / 2 - copy._minY) / (copy._maxY - copy._minY);
          // eslint-disable-line no-underscore-dangle
        }

        // Tag it for joining
        p.region = p.properties.region;
        p.ucName = p.name.toUpperCase();
      });
    }
    setmapData(mapData);
    setcolorAxis(colorAxis);
    setmap(map);
  }, [view, JSON.stringify(censusRegionData), excludeMaxIndex, excludeMinIndex]);

  useEffect(() => {
    Highcharts.mapChart('container', {
      chart: {
        map,
      },
      title: {
        text: '',
        style: {
          fontFamily: 'Open Sans', 
        }
      },

      credits: {
        enabled: false,
      },

      mapNavigation: {
        enabled: false,
        enableButtons: false,
      },

      xAxis: {
        labels: {
          enabled: false,
        },
      },

      exporting: {
        sourceWidth: 600,
        sourceHeight: 500,
      },

      legend: {
        title: {
          text:
            'Index',
          style: {
            fontStyle: 'normal',
            fontWeight: '500',
            fontFamily: 'Open Sans',
            fontSize: '14px',
            color: '#000000'
          },
        },
        symbolRadius: 0,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        enabled: true,
        itemStyle: {
          fontFamily: 'Open Sans',
          fontWeight: 400,
        },
        itemMarginBottom: 5,
      },

      colorAxis: {
        dataClasses: colorAxis,
      },

      tooltip: {
        formatter() {
          const self = this;
          const point = self.point;
          return (view === 'States' || view === 'State Groups')
            ? `${view === 'States' ? 'State' : 'State Group'}: ${view === 'States' ?
            `<b>${point.name}</b>` : `<b>${point.region}</b>`}<br>Index: <b>${point.value}</b>
            <br>Sample: <b>${point.sample}</b><br>Weighted: <b>${point.weighted}</b>
            <br/>Horizontal %: <b>${point.hpct}</b><br/>Vertical %: <b>${point.vpct}</b>`
            : `Region: <b>${point.region}</b><br>Index: <b>${point.value}</b>
            <br>Sample: <b>${point.sample}</b><br>Weighted: <b>${point.weighted}</b>
            <br/>Horizontal %: <b>${point.hpct}</b><br/>Vertical %: <b>${point.vpct}</b>`;
        }
      },

      series: [
        {
          mapData: map,
          nullColor: '#CACACA',
          data: mapData,
          joinBy: ['postal-code', 'code', 'ucName'],
          dataLabels: {
            enabled: true,
            color: '#000000',
            formatter() {
              const self = this;
              return getFormatForQRMap(self, view, geoLabel, indexLabel);
            },
            style: {
              fontSize: (view === 'States' || view === 'State Groups') ? '10px' : '15px',
              'text-anchor': view === 'States' ? 'unset' : 'middle',
              fontFamily: 'Open Sans',
              fontWeight: 700,
            },
          },
        },
        {
          type: 'mapline',
          data: view === 'States' ? lines : [],
          color: 'silver',
        },
      ],
    });
  }, [
    JSON.stringify(mapData),
    JSON.stringify(colorAxis),
    JSON.stringify(lines),
    JSON.stringify(map),
    geoLabel,
    indexLabel,
  ]);

  return (
    <div id="container">
      {/* <HighchartsReact
        highcharts={Highcharts}
        constructorType="mapChart"
        options={options}
      /> */}
    </div>
  );
}

USMapChart.propTypes = {
  censusRegionData: PropTypes.shape({
    stateDetails: PropTypes.arrayOf({}),
    indexGroups: PropTypes.arrayOf({}),
  }),
  view: PropTypes.string,
  geoLabel: PropTypes.bool,
  indexLabel: PropTypes.bool,
  // indexRange: PropTypes.instanceOf(Array),
};

export default USMapChart;
